<template>
  <div class="tag">
    <transition name="fade" mode="out-in">
      <el-tag
        v-if="!inputVisible"
        :size="size"
        :closable="!readonly"
        @dblclick.native="handleEdit"
        @close="handleClose">
        {{value}}
      </el-tag>
      <confirm-input
        v-else
        ref="editTagInput"
        class="input-edit"
        placeholder="请输入标签内容"
        v-model.trim="inputValue"
        maxlength="10"
        show-word-limit
        size="mini"
        @confirm="handleConfirm"
        @cancel="handleCancel"
      />
    </transition>
  </div>
</template>
<script>
import ConfirmInput from "./confirmInput.vue";
export default {
  name: "EditTag",
  components: {
    ConfirmInput
  },
  props: {
    value: {
      type: String,
      default: ""
    },
    index: {
      type: Number,
      default: 0
    },
    readonly: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "small"
    }
  },
  data() {
    return {
      inputVisible: false,
      inputValue: ""
    };
  },
  methods: {
    handleClose() {
      this.$emit("close", this.value, this.index);
    },
    handleEdit() {
      if (this.readonly) {
        return;
      }
      this.inputVisible = true;
      this.inputValue = this.value;
      this.$emit("edit", this.index);
      setTimeout(() => {
        const editTagInput = this.$refs.editTagInput;
        editTagInput && editTagInput.focus();
      }, 500);
    },
    handleCancel() {
      if (this.inputVisible) {
        this.inputVisible = false;
      }
    },
    handleConfirm() {
      this.$emit("confirm", this.inputValue, this.index);
    }
  }
};
</script>
<style lang="scss" scoped>

.fade-enter-active, .fade-leave-active {
  transition: all 0.1s;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}

</style>
